import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs';
import { RequestBuilder } from '../classes/request-builder';
import * as Enum from '../utils/enums';

@Injectable()
export class LogAttivitaService extends BaseService{

  /**
   * Costruttore
   * @param http Servizio di richieste HTTP 
   */
  constructor(http: Http) {
    super(http);
  }

  /**
   * Get list of log
   * @param reqBuilder 
   */
  getAllLog(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('logOperazioni/fetch', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * save log
   * @param reqBuilder 
   */
  saveLog(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('logOperazioni/save', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * export all log
   * @param reqBuilder 
   */
  exportLog(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('logOperazioni/export', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }
}
